import { useEffect } from 'react';
import { markFusionAuthSessionEstablished } from 'modules/v2/utils/fusionAuthSession';

/**
 * FusionAuth Silent Callback
 *
 * This component handles the callback from FusionAuth silent authentication.
 * It runs in a hidden iframe and communicates with the parent window via postMessage.
 *
 * If we reach this page with an authorization code, the silent auth succeeded.
 * If we reach this page with an error, the silent auth failed (no existing session).
 */
const FusionAuthSilentCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (code) {
      // Silent auth succeeded - FusionAuth session is established
      markFusionAuthSessionEstablished();
      window.parent.postMessage({ type: 'fusionauth-session-established' }, window.location.origin);
    } else if (error) {
      // Silent auth failed - user needs to login interactively
      // Common errors: login_required, consent_required, interaction_required
      window.parent.postMessage(
        { type: 'fusionauth-session-failed', error },
        window.location.origin
      );
    } else {
      // No code or error - unexpected state
      window.parent.postMessage(
        { type: 'fusionauth-session-failed', error: 'unknown' },
        window.location.origin
      );
    }
  }, []);

  // This component runs in a hidden iframe, so no visible UI needed
  return null;
};

export default FusionAuthSilentCallback;
